import { commonRequestData, fetchData } from "../../api";

export const obtenerDetallesAdministrador = async ({ id }) => {
    // Combina los datos comunes necesarios para la solicitud con el ID del administrador
    const requestData = {
        ...commonRequestData, // Datos comunes para la solicitud
        id, // ID del administrador a consultar
    };

    // Realiza una solicitud a la API para obtener la información del administrador
    // El endpoint "admins/obtenerAdmins" se utiliza para consultar los datos del administrador específico
    const response = await fetchData("admins/obtenerAdmins", requestData);

    // Retorna la respuesta obtenida de la API con la información del administrador
    return response;
};

export const obtener_Administradores = async () => {
    // Combina los datos comunes necesarios para la solicitud.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (por ejemplo, headers, token).
    };

    // Realiza una solicitud a la API para obtener la lista de administradores.
    // El endpoint "admins" se utiliza para consultar todos los administradores.
    const response = await fetchData("admins", requestData);

    // Retorna la respuesta obtenida de la API con la lista de administradores.
    return response;
};


/**
 * Realiza una solicitud para crear un nuevo usuario en la API.
 *
 * @param {Object} formData - Datos del formulario para la creación del usuario.
 * @returns {Promise<Object>} La respuesta de la API con los datos del usuario creado.
 */
export const fetchCrearUsuario = async ({ formData }) => {
    // Combina los datos comunes necesarios para la solicitud (por ejemplo, headers, token de autenticación).
    const requestData = {
        ...commonRequestData,
        formData,
    };

    // Realiza una solicitud a la API para crear el usuario con los datos proporcionados.
    const response = await fetchData("admins/crear", requestData);

    // Retorna la respuesta obtenida de la API con los datos del usuario creado.
    return response;
};

/**
 * Verifica si un usuario existe en la base de datos utilizando su correo electrónico.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {string} params.email - Correo electrónico del usuario a validar.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, que contiene los datos del usuario si existe.
 */
export const validarSiexisteUsuario = async ({ email }) => {
    // Prepara los datos necesarios para la solicitud, combinando datos comunes y el correo electrónico del usuario.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (headers, token de autenticación, etc.).
        email, // Correo electrónico del usuario a validar.
    };

    // Realiza una solicitud a la API para validar si el usuario existe.
    // El endpoint "admins/validarUsuario" se utiliza para verificar la existencia del usuario.
    const response = await fetchData("admins/validarUsuario", requestData);

    // Retorna la respuesta obtenida de la API.
    return response;
};




/**
 * Realiza una solicitud para la recuperación de contraseña de un usuario.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {string} params.email - Correo electrónico del usuario para la recuperación de contraseña.
 * @returns {Promise<Object>} La respuesta de la API con el resultado de la solicitud.
 */
export const recuperar_Contraseña = async ({ email }) => {
    // Prepara los datos necesarios para la solicitud, combinando datos comunes y el correo electrónico del usuario.
    const requestData = {
        ...commonRequestData, // Incluye datos comunes como headers y token de autenticación.
        email, // Correo electrónico del usuario para la recuperación de contraseña.
    };

    // Realiza una solicitud a la API para iniciar el proceso de recuperación de contraseña.
    // Utiliza el endpoint "admins/recuperar_Contrasena" para gestionar la solicitud.
    const response = await fetchData("admins/recuperar_Contrasena", requestData);

    // Retorna la respuesta obtenida de la API, que incluye el resultado de la solicitud.
    return response;
};

/**
 * Realiza una solicitud para editar los datos de un usuario existente en la API.
 *
 * @param {Object} formData - Datos del formulario con la información actualizada del usuario.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, incluyendo los datos del usuario actualizado.
 */
export const fetchEditarUsuario = async ({ formData }) => {
    // Combina los datos comunes necesarios para la solicitud, como headers y token de autenticación.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, autenticación).
        formData, // Datos del formulario con la información del usuario a editar.
    };

    // Realiza una solicitud a la API para actualizar los datos del usuario.
    // Utiliza el endpoint "admins/editar" para aplicar los cambios proporcionados.
    const response = await fetchData("admins/editar", requestData);

    // Retorna la respuesta obtenida de la API, que contiene los datos del usuario editado.
    return response;
};



/**
 * Realiza una solicitud para cambiar el estado (activo/inactivo) de un usuario en la API.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {number} params.id - ID del usuario cuyo estado será modificado.
 * @param {boolean} params.estado - Nuevo estado del usuario (true para activo, false para inactivo).
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, incluyendo los datos del usuario con el estado actualizado.
 */
export const fetchcambioDeestadoUsuario = async ({ id, estado }) => {
    // Combina los datos comunes necesarios para la solicitud, como headers y token de autenticación.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, autenticación).
        id,                  // ID del usuario a modificar.
        estado,              // Nuevo estado del usuario.
    };

    // Realiza una solicitud a la API para actualizar el estado del usuario.
    // Utiliza el endpoint "admins/estado" para aplicar los cambios.
    const response = await fetchData("admins/estado", requestData);

    // Retorna la respuesta obtenida de la API, que contiene los datos del usuario con el estado actualizado.
    return response;
};

/**
 * Realiza una solicitud para cambiar la clave de un usuario en el sistema.
 *
 * @param {Object} params - Parámetros para la solicitud.
 * @param {number} params.id - ID del usuario cuya clave será modificada.
 * @param {string} params.password - Nueva clave para el usuario.
 * @returns {Promise<Object>} Promesa que resuelve con la respuesta de la API, que incluye los datos del usuario con la clave actualizada.
 */
export const fetchcambioDeclaveSistema = async ({ id, password }) => {
    // Combina los datos comunes necesarios para la solicitud, como headers y token de autenticación.
    const requestData = {
        ...commonRequestData, // Datos comunes para todas las solicitudes (e.g., headers, autenticación).
        id,                  // ID del usuario cuya clave será modificada.
        password,            // Nueva clave para el usuario.
    };

    // Realiza una solicitud a la API para actualizar la clave del usuario.
    // Utiliza el endpoint "admins/fetchcambioDeclaveSistema" para gestionar el cambio.
    const response = await fetchData("admins/fetchcambioDeclaveSistema", requestData);

    // Retorna la respuesta obtenida de la API, que incluye los datos del usuario con la clave actualizada.
    return response;
};
